import Icon from '../components/Icon.vue'

Icon.register({"envelope-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM178.1 262.1C87.4 196.3 88.4 196.1 64 177.2V152C64 138.7 74.7 128 88 128H360C373.3 128 384 138.7 384 152V177.2C359.6 196.1 360.6 196.3 269.9 262.1 259.4 269.8 238.5 288.2 224 288 209.5 288.2 188.6 269.8 178.1 262.1zM384 217.8V360C384 373.3 373.3 384 360 384H88C74.7 384 64 373.3 64 360V217.8C78 228.6 97.3 243 159.3 288 173.5 298.3 197.3 320.1 224 320 250.9 320.1 275 298 288.7 288 350.7 243 370 228.6 384 217.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/envelope-square.js
// module id = uCCX
// module chunks = 0